import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "bootstrap-4-react/lib/components";
import { featureSubmodule, fulfilledBy, settings, SUBF_MARKETPLACEINTEGRATION, unitList } from "../../constant";
import { marketPlaceIntegrationListing } from "../../store/actions/marketplace.action";
import LoaderSpinner from "../common/Loader";
import { checkPermission, computeAutoSelectedSeller } from "../../config/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyFilters, getFilterSellers } from "../../store/actions/rateCard";
import { getAllSellersList } from "../../store/actions";
import PropTypes from "prop-types";
import Select from "react-select";
import DatePickerComponent from "../common/DatePickerComponent";
import { getProductListingBatch } from "../../store/actions/batch.action";

const FilterBatch = (props) => {
    const {
        modalClass,
        setMinWeight,
        setMaxWeight,
        setParcelUnit,
        setFilterApplied,
        filterApplied,
        parcelUnit,
        maxWeight,
        minWeight,
        loader,
        setMarketplaceIntegrationId,
        formData,
        setFormData
    } = props;
    const [showDialog, setShowDialog] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [integrationList, setIntegrationList] = useState([]);
    const [filterCompaniesList, setFilterCompaniesList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const [productListing, setProductListing] = useState([]);
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!filterCompanies?.Entity?.listCompanyMasterOrdersEntity?.length) {
            let data = {
                pageIndex: 1,
                pageSize: 10,
                sortColumn: 'name',
                sortOrder: 'ascending'
            };
            dispatch(fetchCompanyFilters(data));
        } else {
            setFilterCompaniesList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity);
        }
    }, [filterCompanies]);

    useEffect(() => {
        let sellerList = filterAllSellers?.EntityList || [];
        if (sellerList.length) {
            setAllSellers(sellerList);
        } else {
            let sellerData = {
                "pageIndex": 1,
                "pageSize": 10,
                "sortColumn": "name",
                "sortOrder": "ASCENDING",
                "companyIdList": [0],
                screenType: 2,
            };
            dispatch(getFilterSellers(sellerData));
        }
    }, [filterAllSellers]);


    useEffect(() => {
        fetchSellerByCompanyId(formData.companyId);
    }, [formData.companyId]);

    const fetchSellerByCompanyId = async (companyId) => {
        let data = {
            companyIds: companyId ? [companyId] : [],
        };
        let res = await getAllSellersList(data);
        if (res?.data?.Status === 200) {
            let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
                (item) => {
                    return {
                        ...item,
                        sellerName: item.sellerAndCompany
                    };
                }
            );
            setAllSellers(dataList);
            // Auto-select the lone seller when the company has exactly one.
            // Also re-apply when the previously selected seller doesn't belong to the
            // newly fetched list (e.g. user changed company to another single-seller company).
            const lone = computeAutoSelectedSeller(dataList);
            if (lone) {
                setFormData((prev) => {
                    const currentSellerId = Number(prev?.sellerId) || 0;
                    const stillValid = currentSellerId > 0 && dataList.some((s) => Number(s.id) === currentSellerId);
                    if (stillValid) return prev;
                    return { ...prev, sellerId: lone.id };
                });
            }
        }
    }

    useEffect(() => {
        if (!showDialog) {
            setFormData({
                ...formData,
                unit: parcelUnit || "INCH",
                minWeight: minWeight,
                maxWeight: maxWeight,
            });
        } 
        if (!integrationList.length) {
            fetchMarketPlaceListing();
        }
    }, [showDialog]);

    useEffect(() => {
        if (Number(formData.sellerId) > 0 && Number(formData.companyId) > 0) {
            fetchProductLisitng();
        }
    }, [formData.companyId, formData.sellerId]);

    const fetchProductLisitng = async () => {
        let data = {
            sortColumn: "",
            sortOrder: "DESCENDING",
            searchKeyword:"",
            sellerIdList:[Number(formData.sellerId) || 0],
            companyIdList:[Number(formData.companyId) || 0],
            productCondition:0,
            excludePaging: true,
        };
        setShowLoader(true);
        let res = await getProductListingBatch(data);
        setShowLoader(false);
        if (res && res?.data?.Status === 200) {
            let options = res?.data?.Entity?.listInventoryEntity.map((item) => ({
                ...item,
                label: `[${item.productSku}] ${item.productName}`,
                value: item.id,
            }));
            setProductListing(options || []);
        } else {
            setProductListing([]);
        }
    }

    const fetchMarketPlaceListing = async () => {
        let data = {
            company_seller_id: '',
        };
        setShowLoader(true);
        await marketPlaceIntegrationListing(data).then((res) => {
            if (res && res?.data?.Status === 200) {
                setIntegrationList(res?.data?.EntityList);
            } else {
                setIntegrationList([]);
            }
        }).catch((err) => {
            console.log(err)
        })
        setShowLoader(false);
    };

    const handleFilterBatch = () => {
        handleFilterDialog();
        setMinWeight(Number(formData.minWeight));
        setMaxWeight(Number(formData.maxWeight));
        setMarketplaceIntegrationId(formData.marketplaceIntegrationId);
        setParcelUnit(formData.unit);
        setFilterApplied(!filterApplied);
        
    };

    const handleFieldChange = (e, field) => {
        const { value, checked, type } = e.target;
        setFormData({
            ...formData,
            [field]: type === "checkbox" ? checked : value,
        });
    };

    const handleFilterDialog = () => {
        setShowDialog(!showDialog);
    };

    const clearFilter = () => {
        setMinWeight(0);
        setMaxWeight(0);
        setParcelUnit("");
        setFilterApplied(!filterApplied);
        setMarketplaceIntegrationId(null);
        setFormData({
            ...formData,
            unit: "INCH",
            searchText: "",
            companyId: 0,
            sellerId: 0,
            marketplaceIntegrationId: '',
            minWeight: '',
            maxWeight: '',
            includeCombination: false,
            productSkus: [],
            startDate: null,
            endDate: null,
            orderedQuantity: ''
        });
        setDateRange([null, null]);
    };

    const handleBlur = (e, field) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [field]: value.trim(),
        });
    };

    const handleDateChange = (date) => {
        setDateRange(date);
        setFormData({
            ...formData,
            startDate: date[0],
            endDate: date[1],
        });
    };

    const handleMultiSelect = (selectedOptions, field) => {
        setFormData({
            ...formData,
            [field]: selectedOptions,
        });
    };

    const handleFulfillmentChange = (event) => {
        setFormData({
            ...formData,
            fulfilledBy: event.target.value,
        });
    }

    return (
        <>
            <Button
                className="cus-seconday-bg-btn"
                onClick={handleFilterDialog}
                disabled={loader}
            >
                Filter Orders
            </Button>
            {parcelUnit && (
                <button
                    className="ml-2 btn cus-primary-transparent-btn"
                    id="clearFilterBtn"
                    onClick={clearFilter}
                    disabled={loader}
                >
                    Clear Filter
                </button>
            )}
            {showDialog && (
                <Modal
                    className={modalClass || ""}
                    size="lg"
                    show={showDialog}
                    onHide={handleFilterDialog}
                >
                    <Modal.Header>
                        <div className="modal-main-div">
                            <span className="modal-m-text">Filter {showLoader && <LoaderSpinner />}</span>
                        </div>
                        <div className="modalDeleteWrapper">
                            <button
                                id="closeBtn"
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => handleFilterDialog()}
                            ></button>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="filterBatch createBatchForm">
                            <div className="row">
                                <div className="col-12">
                                    <label htmlFor="searchText">Search</label>
                                    <input
                                        className="form-control"
                                        id="searchText"
                                        name="searchText"
                                        placeholder="Search by Order Number, Marketplace Order Id or Customer Name"
                                        type="text"
                                        onChange={(e) => handleFieldChange(e, "searchText")}
                                        value={formData.searchText}
                                        onBlur={(e) => handleBlur(e, "searchText")}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="companyId">Company</label>
                                    <select
                                        className="unitDropdown form-control"
                                        id="companyId"
                                        onChange={(e) =>
                                            handleFieldChange(e, "companyId")
                                        }
                                        value={formData.companyId}
                                    >
                                        <option value={0}>Select Company</option>
                                        {filterCompaniesList.length > 0 &&
                                            filterCompaniesList.map((item) => (
                                                <option
                                                    key={`${item.Id}`}
                                                    value={item.Id}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="sellerId">Seller</label>
                                    <select
                                        className="unitDropdown form-control"
                                        id="sellerId"
                                        onChange={(e) =>
                                            handleFieldChange(e, "sellerId")
                                        }
                                        value={formData.sellerId}
                                    >
                                        <option value={0}>Select Seller</option>
                                        {allSellers.length > 0 &&
                                            allSellers.map((item) => (
                                                <option
                                                    key={`${item.id}`}
                                                    value={item.id}
                                                >
                                                    {item.sellerName}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-12 mb-2">
                                    <div className="headingSkuCount">Product SKU Search</div>
                                    <div className="">
                                        <input 
                                            type="checkbox"
                                            checked={formData?.includeCombination}
                                            id="includeCombination"
                                            onChange={(e) => handleFieldChange(e, "includeCombination")}
                                        />
                                        <label htmlFor="includeCombination" className="pl-2">Include Combination SKU Orders</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={productListing}
                                        classNamePrefix="list"
                                        id='taskStatusList'
                                        isDisabled={showLoader}
                                        name="taskStatusList"
                                        value={formData?.productSkus}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "productSkus")
                                        }
                                        placeholder="Search by Product Name or SKU"
                                    />
                                </div>
                            </div>
                            {checkPermission(settings, SUBF_MARKETPLACEINTEGRATION, '', featureSubmodule, employeePermissions) && (
                                <div className="row">
                                    <div className="col-12">
                                        <label htmlFor="marketplaceIntegrationId">Marketplace Integration</label>
                                        <select
                                            className="unitDropdown form-control"
                                            id="marketplaceIntegrationId"
                                            onChange={(e) =>
                                                handleFieldChange(e, "marketplaceIntegrationId")
                                            }
                                            value={formData.marketplaceIntegrationId}
                                        >
                                            <option value={''}>Select Integration</option>
                                            {integrationList.length > 0 &&
                                                integrationList.map((item) => (
                                                    <option
                                                        key={`${item.integration_id}`}
                                                        value={item.integration_id}
                                                    >
                                                        {item.integration_name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="minWeight">Select Dates</label>
                                    <DatePickerComponent
                                        className="date-picker form-control pr-4"
                                        isRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            handleDateChange(update);
                                        }}
                                        dateFormat="MM-dd-yyyy"
                                        isClearable={true}
                                        iconPosition="right"
                                        popperPlacement="top-end"
                                        placeholderText="Select Date Range"
                                        maxDate={new Date()}
                                    />
                                </div>
                                <div className="col-6">
                                    <label htmlFor="orderedQuantity">Order Item Qty</label>
                                    <input
                                        min={0}
                                        maxLength={5}
                                        onChange={(e) => handleFieldChange(e, "orderedQuantity")}
                                        className="form-control"
                                        id="orderedQuantity"
                                        type="number"
                                        value={formData.orderedQuantity}
                                        onKeyDown={(evt) =>
                                            ["e", "E", "+", "-"].includes(evt.key) &&
                                            evt.preventDefault()
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="unit">Fulfillment</label>
                                    <select
                                        className="form-control"
                                        name="fulfilledBy"
                                        value={formData.fulfilledBy}
                                        onChange={handleFulfillmentChange}
                                    >
                                        {fulfilledBy.length > 0 &&
                                            fulfilledBy.map((item, index) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="unit">Unit</label>
                                    <select
                                        className="unitDropdown form-control"
                                        id="unit"
                                        onChange={(e) => handleFieldChange(e, "unit")}
                                        value={formData.unit}
                                    >
                                        {unitList.length > 0 &&
                                            unitList.map((item, index) => (
                                                <option key={item.id} value={item.value}>
                                                    {item.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="minWeight">Min Weight</label>
                                    <input
                                        min={0}
                                        maxLength={5}
                                        onChange={(e) => handleFieldChange(e, "minWeight")}
                                        className="form-control"
                                        id="minWeight"
                                        type="number"
                                        value={formData.minWeight}
                                        onKeyDown={(evt) =>
                                            ["e", "E", "+", "-"].includes(evt.key) &&
                                            evt.preventDefault()
                                        }
                                    />
                                </div>
                                <div className="col-6">
                                    <label htmlFor="maxWeight">Max Weight</label>
                                    <input
                                        min={0}
                                        maxLength={5}
                                        onChange={(e) => handleFieldChange(e, "maxWeight")}
                                        className="form-control"
                                        id="maxWeight"
                                        type="number"
                                        value={formData.maxWeight}
                                        onKeyDown={(evt) =>
                                            ["e", "E", "+", "-"].includes(evt.key) &&
                                            evt.preventDefault()
                                        }
                                    />
                                </div>
                                <div className="col error">
                                    {Number(formData.minWeight) > Number(formData.maxWeight)
                                        ? "Min weight cannot be greater than Max weight"
                                        : ""}
                                </div>
                            </div>

                            <div className="formActions">
                                <Button
                                    className="btn cus-seconday-bg-btn"
                                    onClick={() => handleFilterDialog()}
                                >
                                    Cancel
                                </Button>
                                <button
                                    disabled={
                                        Number(formData.minWeight) > Number(formData.maxWeight)
                                    }
                                    className="btn cus-seconday-bg-btn marginLeft5"
                                    onClick={handleFilterBatch}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

FilterBatch.propTypes = {
    modalClass: PropTypes.string,
    setMinWeight: PropTypes.func,
    setMaxWeight: PropTypes.func,
    setParcelUnit: PropTypes.func,
    setFilterApplied: PropTypes.func,
    filterApplied: PropTypes.bool,
    parcelUnit: PropTypes.string,
    maxWeight: PropTypes.number,
    minWeight: PropTypes.number,
    loader: PropTypes.bool,
    setMarketplaceIntegrationId: PropTypes.func,
    formData: PropTypes.object,
    setFormData: PropTypes.func
};

export default FilterBatch;
